export default theme => ({
  dashboard_header_content: {
    justifyContent: "space-between",
    fontSize: 12,
    right: 0,
  },
});
